export default __webpack_public_path__ + "static/media/cp_geo_mq.9cdae873.svg";